<template>
	<!-- renderless: registers the app-update refresh prompt -->
</template>

<script setup>
import { useToast } from '/app/composables/toast';
import { registerAppUpdateRefreshPrompt } from '/app/composables/app';
import { useI18n } from 'vue-i18n';

const toast = useToast();
const { t } = useI18n();

registerAppUpdateRefreshPrompt((reload) => {
	toast(t('component.app-update.content', { appName: 'Bignerve' }), {
		duration: 10000,
		action: {
			label: t('component.app-update.action.refresh'),
			onClick: () => reload(true),
		},
		cancel: {
			label: t('component.app-update.action.dismiss'),
		},
	});
});
</script>
